<template>
  <div v-if="isPhysician && showSurvey && showDialog" :class="{ 'survey-overlay': survey?.mandatory }">
    <div :class="['survey-wrapper', { 'survey-wrapper-mandatory': survey?.mandatory }]">
      <v-card elevation="0" v-if="!done">
        <v-card-title class="d-flex justify-space-between flex-nowrap align-start">
          <span class="break-word">{{ question.text }}</span>
          <v-btn large icon @click="closeDialog" v-if="!survey?.mandatory"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="d-flex justify-space-between">
          <component
            :is="currentComponent"
            :color="'#1976d2'"
            :cols="question.options?.length"
            :options="question.options"
            v-model="answer"
            @input="saveAnswer"
          />
        </v-card-text>
      </v-card>
      <v-card elevation="0" v-else>
        <v-card-title class="d-flex justify-space-between">
          <span>Suas respostas foram salvas</span>
          <v-btn large icon @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-subtitle> Obrigado por responder nosso questionário! </v-card-subtitle>
      </v-card>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import GradientRange from '@/components/GradientRange.vue'
import RadioOptions from '@/components/RadioOptions.vue'
const {
  mapGetters: authGettersMap,
  mapActions: authActionsMap,
  mapState: authStateMap,
} = createNamespacedHelpers('auth')
export default {
  name: 'SurveyComponent',
  components: { GradientRange, RadioOptions },
  data() {
    return {
      currentQuestion: 0,
      survey: null,
      question: null,
      answer: null,
      currentComponent: null,
      surveyAnswer: [],
      done: false,
      showDialog: false,
      showNps: false,
      showMedicine: false,
      surveyList: [],

      defaultOptions: [
        {
          text: 'Sim',
          value: 'SIM',
        },
        {
          text: 'Não',
          value: 'NAO',
        },
        {
          text: 'Ainda não tenho experiência com imunobiológico',
          value: 'SEM_EXPERIENCIA',
        },
      ],
    }
  },
  watch: {
    done(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.closeDialog()
        }, 1500)
      }
    },
    survey(newVal) {
      if (this.surveyList.length > 0) {
        if (newVal?.questions) {
          switch (newVal.questions[this.currentQuestion].type) {
            case 'range':
              this.currentComponent = GradientRange
              break
            case 'radio':
              this.currentComponent = RadioOptions
              break

            default:
              this.currentComponent = null
          }
        }

        if ((newVal.type !== 'NPS' && newVal.type !== 'FEEDBACK') || !newVal?.questions || !this.currentComponent) {
          this.showDialog = false
          const newList = this.surveyList.filter((elem, index) => index > 0)
          this.surveyList = newList
          this.survey = newList.length > 0 ? newList[0] : null
        } else {
          this.showDialog = true
          this.question = this.survey.questions[this.currentQuestion]
        }
      } else {
        this.done = true
      }
    },
    isPhysician(newVal) {
      if (newVal && !this.isAdmin) {
        this.getPendingSurveys()
      }
    },
  },
  methods: {
    ...authActionsMap(['setShowSurvey']),
    closeDialog() {
      this.showDialog = false
      this.setShowSurvey(false)
    },
    async saveAnswer() {
      this.surveyAnswer.push({ question: this.survey.questions[this.currentQuestion].text, value: this.answer })
      this.answer = null
      this.currentQuestion++
      if (this.currentQuestion >= this.survey.questions.length) {
        try {
          await this.$api.saveUserSurveyAnswer(this.survey.id, this.surveyAnswer, this.userId)
          this.currentQuestion = 0
          this.surveyAnswer = []
          const newList = this.surveyList.filter((elem, index) => index > 0)
          this.surveyList = newList
          this.survey = newList.length > 0 ? newList[0] : null
        } catch {
          this.$root.error('Não foi possível salvar sua resposta, tente novamente mais tarde.')
        }
      } else {
        this.question = this.survey.questions[this.currentQuestion]
      }
    },
    async getPendingSurveys() {
      try {
        const result = await this.$api.getUserPendingSurveys()
        this.surveyList = result
        this.survey = result.length > 0 ? result[0] : null
      } catch (error) {
        this.showDialog = false
        console.error(error)
        this.$root.error(error)
      }
    },
  },
  computed: {
    ...authGettersMap(['userId', 'isPhysician', 'isAdmin']),
    ...authStateMap(['showSurvey']),
  },
  async mounted() {
    if (this.isPhysician && !this.isAdmin) {
      await this.getPendingSurveys()
    }
  },
}
</script>

<style scoped>
.survey-wrapper {
  position: absolute;
  bottom: 24px;
  right: 24px;
  border-radius: 8px;
  border: 2px solid #1976d2;
  box-shadow: 2px 2px 4px 2px #0a3e7236;
  padding: 12px;
  background: #ffffff;
  max-width: 600px;
  min-width: 300px;
}
.survey-wrapper-mandatory {
  position: static;
}
.break-word {
  word-break: break-word;
}

.survey-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #3838385c;
}
</style>
